import * as _ from 'lodash';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'fc-list',
    templateUrl: './fc-list.component.html',
    styleUrls: ['./fc-list.component.less'],
    standalone: false
})
export class FcListComponent {
    @Input() e2eHook: string;

    @Input() disabled: boolean;

    @Output() onItemClicked = new EventEmitter<any>();

    private lastSelectedItems: [ListItem, ListItem, ListItem];
    private _list: ListItem[];
    public showBlur: boolean;

    constructor() {
        this.lastSelectedItems = [null, null, null];
        this.showBlur = false;
    }

    @Input()
    public set list(list: ListItem[]) {
        this._list = list;
        this.setSelectedItem(list);
    }

    public get list() {
        return this._list;
    }

    public onAnyLevelItemSelected(...items: ListItem[]) {
        const selectedItem = _.last(items);
        if (this.disabled || selectedItem.isActive || selectedItem.isDisabled) {
            return;
        }

        this.closeLastSelectedItems();
        _.forEach(items, (item: ListItem, level: number) => {
            item.showSubList = true;
            this.lastSelectedItems[level] = item;
        });
        selectedItem.isActive = true;
        this.onItemClicked.emit(selectedItem.value);
    }

    private closeLastSelectedItems() {
        _.forEach(this.lastSelectedItems, (item: ListItem) => {
            _.set(item, 'showSubList', false);
            _.set(item, 'isActive', false);
        });
    }

    private setSelectedItem(list: ListItem[] | null, level = 0) {
        const selectedItem = _.find(list, { isActive: true });
        if (selectedItem) {
            // Setting showSubList to true should not be necessary because isActive means that the subList should be shown.
            // We just enforce it in case the list has non-consistent values, wich we are not validating.
            selectedItem.showSubList = true;
            this.lastSelectedItems[level] = selectedItem;
            this.setSelectedItem(selectedItem.subList, level + 1);
        }
    }
}

interface Item<T = any> {
    text: string;
    value: T;
}

interface ListItem extends Item {
    isActive?: boolean;
    isDisabled?: boolean;
    showSubList?: boolean;
    subList?: ListItem[];
}
